import React from 'react';
import { appName } from '../../config/config';
import { NavLink } from 'react-router-dom';

const Carousel = () => {
    return ( <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
        <div className="carousel-inner">
            <div className="carousel-item active">
                <img className="w-100" src="/assets/img/carousel-1.png" alt="Image" />
                <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                    <div className="p-3" style={{maxWidth: 900}}>
                        <h1 className="display-1 text-white mb-md-4 animated zoomIn">Navigating Your Path to a New Beginning</h1>
                        <h5 className="text-white mb-3 animated slideInDown">Whether you're seeking a fresh start, reuniting with loved ones, or chasing new opportunities abroad, {appName} promises personalized support and expert direction every step of the way. It's not just about relocation—it's about transformation.</h5>
                        <a href="quote.html" className="d-none btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">Free Quote</a>
                        <NavLink to="/contact" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">Contact Us</NavLink>
                    </div>
                </div>
            </div>
            <div className="carousel-item">
                <img className="w-100" src="/assets/img/carousel-2.png" alt="Image" />
                <div className="carousel-caption d-flex flex-column align-items-center justify-content-center">
                    <div className="p-3" style={{maxWidth: 900}}>
                        <h1 className="display-1 text-white mb-md-4 animated zoomIn">Immigration Made Simple</h1>
                        <h5 className="text-white mb-3 animated slideInDown">From visa applications to legal documentation, {appName} assures clients that expert help is just a step away. </h5>
                        <a href="quote.html" className="d-none btn btn-primary py-md-3 px-md-5 me-3 animated slideInLeft">Free Quote</a>
                        <NavLink to="/contact" className="btn btn-outline-light py-md-3 px-md-5 animated slideInRight">Contact Us</NavLink>
                    </div>
                </div>
            </div>
        </div>
        <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel"
            data-bs-slide="prev">
            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Previous</span>
        </button>
        <button className="carousel-control-next" type="button" data-bs-target="#header-carousel"
            data-bs-slide="next">
            <span className="carousel-control-next-icon" aria-hidden="true"></span>
            <span className="visually-hidden">Next</span>
        </button>
    </div> );
}
 
export default Carousel;